//http://registro.adelanta.mx/app
/*const CONFIG_PRODUCCION_PROD = {
  url: 'http://registro.adelanta.mx/api/',
  url_static: 'http://registro.adelanta.mx/content/static/',
  url_token: 'http://registro.adelanta.mx/token',
  url_social: 'http://registro.adelanta.mx/api/',
}*/

const CONFIG_PRODUCCION_PROD = {
  url: 'https://www.anticipa.com.mx:451/RegistroApi/api/',
  url_static: 'https://www.anticipa.com.mx:451/RegistroApi/content/static/',
  url_token: 'https://www.anticipa.com.mx:451/RegistroApi/token',
  url_social: 'https://www.anticipa.com.mx:451/RegistroApi/api/',
  url_SAT: "https://www.anticipa.com.mx:451/MesaApi/api/"
}

const CONFIG_PREPROD = {
  url: 'http://preprod.anticipa.com.mx/RegistroApi/api/',
  url_static: 'http://preprod.anticipa.com.mx/RegistroApi/content/static/',
  url_token: 'http://preprod.anticipa.com.mx/RegistroApi/token',
  url_social: 'http://preprod.anticipa.com.mx/RegistroApi/api/',
  url_SAT: "http://testing.anticipa.com.mx/MesaControlApi/api/"
}

const CONFIG_TESTING = {
  url: 'http://testing.anticipa.com.mx/RegistroApi/api/',
  url_static: 'http://testing.anticipa.com.mx/RegistroApi/content/static/',
  url_token: 'http://testing.anticipa.com.mx/RegistroApi/token',
  url_social: 'http://testing.anticipa.com.mx/RegistroApi/api/',
  url_SAT: "http://testing.anticipa.com.mx/MesaControlApi/api/"
  //url_SAT: "http://localhost:50745/api/"
}

const CONFIG_LOCAL = {
  url: 'http://localhost:52802/api/',
  url_static: 'http://localhost:52802/content/static/',
  url_token: 'http://localhost:52802/token',
  url_social: 'http://localhost:52802/api',
  url_SAT: "http://localhost:50745/api/"
}



export const cripKey = "8080808080808080";

//export const CONFIG = CONFIG_LOCAL;
//export const CONFIG = CONFIG_TESTING;
//export const CONFIG = CONFIG_PREPROD;
export const CONFIG = CONFIG_PRODUCCION_PROD;




// WEBPACK FOOTER //
// ./src/app/config.ts